var FlashButtonSizes = /* @__PURE__ */ ((FlashButtonSizes2) => (FlashButtonSizes2.SMALL = "sm", FlashButtonSizes2.LARGE = "lg", FlashButtonSizes2))(FlashButtonSizes || {});
export {
  FlashButtonSizes
};
//# sourceMappingURL=constants.js.map
